<template>
  <div class="k-time-picker">
    <div class="picker" @click="pickerVisible = !pickerVisible" :class="{'disabled': disabled}">
      <div>{{ value }}</div>
      <div class="icon"><KkIcon name="ic_clock_line" size="sm" /></div>
    </div>
    <KkDropdown ref="KkDropdownRef" v-if="pickerVisible" class="drop-down">
      <KkSelectOption
        v-for="(option, index) of options"
        :key="index"
        :value="option"
        @click="handleClick(index)"
        :is-disabled="(!!startTime && option < startTime) || (!!endTime && option > endTime)"
        :style="{ color: value === option ? 'var(--kk-color-text-primary-darker)' : '' }"
      >
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <span>{{ option }}</span>
          <div v-if="value === option"><KkIcon name="ic_check_line" size="sm" style="color: var(--kk-color-text-primary-darker)" /></div>
        </div>
      </KkSelectOption>
    </KkDropdown>
  </div>
</template>

<script>
import { KkDropdown, KkSelectOption, KkIcon } from '@kkday/web-design-system'
import dayjs from 'dayjs'

export default {
  components: {
    KkDropdown,
    KkSelectOption,
    KkIcon
  },
  props: {
    value: {
      type: String,
      default: '00:00'
    },
    format: {
      type: String,
      default: 'HH:mm'
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      defualt: ''
    },
    step: { // 间隔，以分为单位
      type: String,
      default: '30'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      pickerVisible: false,
      start: '00:00:00',
      end: '23:59:59'
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const currentDate = dayjs().format('YYYY-MM-DD')
      const startDateTime = `${currentDate} ${this.start}`
      const endDateTime = `${currentDate} ${this.end}`
      for (let time = dayjs(startDateTime); time <= dayjs(endDateTime); ) {
        this.options.push(time.format(this.format))
        time = time.add(30, 'minute')
      }
    },
    handleClick(index) {
      this.pickerVisible = false
      this.$emit('input', this.options[index])
    }
  }
}
</script>

<style lang="less" scoped>
.k-time-picker {
  position: relative;
  .picker {
    border: 1px solid var(--kk-color-border-light);
    border-radius: var(--kk-radius-md);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    padding: 14px 12px;
    .icon {
      margin-left: var(--kk-spacing-3);
    }
    &:hover {
      border-color: #212121;
      cursor: pointer;
    }
  }
  .drop-down {
    position: absolute;
    z-index: 10;
    top: 52px;
    width: 100%;
  }
  .disabled {
    border: 1px solid #E6E9ED !important;
    color: #BABBBE !important;
    background-color: #F1F4F8 !important;
    pointer-events: none;
  }
}
</style>
